export default __webpack_public_path__ + "static/media/oscer-pres-faecal-incontinence.baa64cf9.svg";